'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Stepper = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _StepperStyle = require('./Stepper.style.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Stepper = exports.Stepper = function Stepper(_ref) {
  var activeStep = _ref.activeStep,
      className = _ref.className,
      children = _ref.children,
      linear = _ref.linear;

  var steps = _react.Children.map(children, function (step, index) {
    var controlProps = { linear: linear };

    if (activeStep === index) {
      controlProps.active = true;
    } else if (linear && activeStep > index) {
      controlProps.completed = true;
    } else if (linear && activeStep < index) {
      controlProps.disabled = true;
    }

    return _react2.default.cloneElement(step, (0, _extends3.default)({}, step.props, controlProps));
  });

  return _react2.default.createElement(
    'div',
    { className: className + ' row' },
    steps
  );
};

Stepper.propTypes = {
  /**
   * Used to determine the which step is active.  Accepts an index.  This is designed
   * to be as flexible as possible.  For reference, consider how FourTrack handles activeStep:
   *
   * const routeMap = [
   *    '/checkin/subject',
   *    '/checkin/study',
   *    '/checkin/consent'
   *    ];
   *
   *  const pathName = function that returns current path name
   *
   *  < Stepper activePath={routeMap.indexOf(pathName)} ... >
   *    [ . . . ]
   *  < /Stepper >
   *
   *  There are plenty of creative ways to implement similar functions that determine
   *  the current path.
   */
  activeStep: _propTypes2.default.number,
  /**
   * This property is required to apply glamorous styles to the component.
   * It is not necessary to add a className,
   * but it will be merged with the glamorous className if you do
   */
  className: _propTypes2.default.string,
  /**
   * The children of the component, is generally and instance of the Step component
   */
  children: _propTypes2.default.node,
  /**
   * Determines whether the Stepper is linear or not.
   * For instance, FourTrack utilizes a linear stepper.
   * In a linear stepper, the current active step must be completed before being allowed
   * to click the subsequent step.  Non-Linear steppers do not have this behavior inherently,
   * but it could be implemented through utilizing the disable prop on each step.
   */
  linear: _propTypes2.default.bool
  /**
   * The UI element that is styled according to whether the current step has
   * been visited or is completed.
   * This will default to a shallow rectangle that renders bellow your Step content.
   * Note: If you would like your progressIndicator to be different for every step,
   * this prop can accept an array to do just that.  Please ensure that your
   * progressIndicators are ordered the same as your Steps.
   */
};

Stepper.defaultProps = {
  linear: true
};

exports.default = (0, _glamorous2.default)(Stepper)(_StepperStyle.defaultStyle);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/Stepper/Stepper.js
// module id = 625
// module chunks = 0